export default {
  infotech: `Infotech Group`,
  nonamePage: `Безымянная страница`,
  createResourceType: `Создать тип ресурса`,
  editResourceType: `Тип ресурса`,
  createResource: `Создать ресурс`,
  editResource: `Редактировать ресурс`,
  createEvent: `Создать событие`,
  addEventToCalendar: `Добавить событие в календарь`,
  addEventToPlan: `Добавить событие в план`,
  editEvent: `Редактировать событие`,
  editEventType: `Тип события`,
  createEventType: `Создать тип события`,
}
